import classNames from "classnames";
import "./summary.scss";

export interface CardSummaryProps {
  summaryTitle?: string;
  summaryContent?: ISummary[];
  children?: React.ReactChild;
  isGray?: boolean;
}

export interface ISummary {
  summarySubTitle?: string;
  summaryColumns: ISummaryCol[];
}

export interface ISummaryCol {
  colTitle: string;
  colContent: any;
}

export const CardSummary = (props: CardSummaryProps) => {
  return (
    <div className={classNames("summary-card-wrapper", {"isGrayed": props.isGray})}>
      {props.summaryTitle && (
        <h2 className="summary-title">
          {props.summaryTitle}
        </h2>
      )}
      {props?.summaryContent && (
        <div className="summary-desc">
          {props.summaryContent.map(({ summaryColumns, summarySubTitle }, index) =>
            <div key={`${summarySubTitle}${index}`}>
              {summarySubTitle && <h3>{summarySubTitle}</h3>}
              {summaryColumns.map((column, index) =>
                <div className="row" key={`${column.colContent}${index}`}>
                  <div className="col-sm-6">
                    {column.colTitle}
                  </div>
                  <div className="col-sm-6">
                    {column.colContent}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {props?.children && props.children}
    </div>
  )
}